<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />
        <b-card>
            <div v-if="!loaded">
                <img src="assets/ajax-loader.gif" style="padding: 10px;" />
            </div>
            <div v-if="loaded" id="report-body" class="w-100">
                <div v-if="result.length > 0">
                    <b-table-simple bordered>
                        <b-thead head-variant="dark">
                            <tr>
                                <th>Item Name</th>
                                <th>Reason</th>
                                <th>Note</th>
                                <th>Month</th>
                                <th>Date</th>
                                <th>Adjustment</th>
                                <th>Cost</th>
                                <th>Value</th>
                                <th>Created By</th>
                            </tr>
                        </b-thead>

                        <tbody>
                            <tr :key="item.id" v-for="item in result">
                                <td>{{ item.inventory_item }}</td>
                                <td>{{ item.reason }}</td>
                                <td>{{ item.note }}</td>
                                <td>{{ item.adjustment_month }}</td>
                                <td>{{ item.adjustment_date }}</td>
                                <td>{{ item.adjustment.toFixed(4) }}</td>
                                <td>{{ _toCurrency(item.cost) }}</td>
                                <td>{{ _toCurrency(item.value) }}</td>
                                <td>{{ item.adjusted_by }}</td>
                            </tr>
                        </tbody>
                    </b-table-simple>
                </div>
                <div v-else>
                    <i>No records available</i>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import Report from "@/mixins/report.js";
export default {
    components: {
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("month"),
                    end: this.getEndDate("month"),
                    datePickerOptions: {
                        // format: this.getDateFormat()
                        format: "MMM YYYY"
                    },
                    ignoreFormat: 1
                };
            }
        }
    },
    data() {
        return {
            locale: "en-US",
            loaded: true,
            meta: "",
            resource: "",
            params: "",
            code: "",
            result: [],
            renderedDateTime: moment().format("lll"),
            title: "Inventory Adjustments",
            dateRange: ""
        };
    },
    computed: {},
    mounted() {
        let self = this;
        self.data.isShowDateRange = true;
        self.data.isShowItemClass = true;
        self.data.isShowItemStatus = true;

        this._getSetting().then(() => {
            self.data.start = self.getStartDate("month");
            self.data.end = self.getEndDate("month");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.data.itemClass = 1;
            self.init();
        });

        self.data.datePickerOptions.format = "MMM YYYY";

        self.$root.$on("report-filter-date-range:refresh", this.init);
    },
    beforeDestroy: function () {
        this.data.isShowItemClass = false;
        this.data.isShowItemStatus = false;
        this.$root.$off("report-filter-date-range:refresh", this.init);
        this.data.status = 2;
    },
    methods: {
        init(params) {
            let self = this;
            self.data.ignoreFormat = 1;

            if (params) {
                this.data.from = params.from;
                this.data.to = params.to;
                this.data.start = params.start;
                this.data.end = params.end;
                this.data.itemClass = params.itemClass;
                this.data.status = params.status;
            }

            self.loaded = false;
            self.dateRange = self.getDateRange(self.data.from, self.data.to);

            return this.$http
                .get(
                    process.env.BARRACUDA +
                        "/report/reports/" +
                        self.$route.params.id,
                    {
                        params: {
                            from: params ? params.from : self.data.start.unix(),
                            to: params ? params.to : self.data.end.unix(),
                            item_class: params
                                ? params.itemClass
                                : self.data.itemClass,
                            status : params
                                ? params.status
                                : self.data.status,

                        }
                    }
                )
                .then(function (response) {
                    self.meta = response.data.response.resource.meta;
                    self.resource = response.data.response.resource.results;
                    self.locale = self.meta.locale.replace("_", "-");
                    self.code = response.status;
                    self.params = {
                        results: response.data.response.resource.results
                    };
                    self.title = self.capitalize(self.meta.title);
                    self.dynamicPageTitle(self.title);

                    if (self.code === 200) {
                        self.loaded = true;
                        self.result = self.params.results;
                        self.renderedDateTime = moment()
                            .tz(self.meta.timezone)
                            .format("lll");
                    }
                });
        }
    }
};
</script>
